import api from '../api/api';
const BASE_URL = import.meta.env.VITE_APP_API_URL;

export const adminTokenService = {
  /**
   * Buscar todos os usuários logados
   */
  buscarUsuariosLogados: async () => {
    try {
      const url = `${BASE_URL}/admin/tokens/usuarios-logados`;
      const response = await api.get(url);
      return response.data;
    } catch (error) {
      console.error("Erro ao buscar usuários logados:", error);
      throw new Error("Erro ao buscar usuários logados.");
    }
  },

  /**
   * Buscar estatísticas dos tokens
   */
  buscarEstatisticas: async () => {
    try {
      const url = `${BASE_URL}/admin/tokens/estatisticas`;
      const response = await api.get(url);
      return response.data;
    } catch (error) {
      console.error("Erro ao buscar estatísticas:", error);
      throw new Error("Erro ao buscar estatísticas.");
    }
  },

  /**
   * Revogar token específico
   * @param {number} tokenId - ID do token
   */
  revogarToken: async (tokenId) => {
    try {
      const url = `${BASE_URL}/admin/tokens/revogar/${tokenId}`;
      const response = await api.post(url);
      return response.data;
    } catch (error) {
      console.error("Erro ao revogar token:", error);
      throw new Error("Erro ao revogar token.");
    }
  },

  /**
   * Revogar todos os tokens de um usuário
   * @param {string} userLogin - Login do usuário
   */
  revogarTodosTokensUsuario: async (userLogin) => {
    try {
      const url = `${BASE_URL}/admin/tokens/revogar-usuario/${userLogin}`;
      const response = await api.post(url);
      return response.data;
    } catch (error) {
      console.error("Erro ao revogar tokens do usuário:", error);
      throw new Error("Erro ao revogar tokens do usuário.");
    }
  },

  /**
   * Limpar tokens expirados
   */
  limparTokensExpirados: async () => {
    try {
      const url = `${BASE_URL}/admin/tokens/limpar-expirados`;
      const response = await api.post(url);
      return response.data;
    } catch (error) {
      console.error("Erro ao limpar tokens expirados:", error);
      throw new Error("Erro ao limpar tokens expirados.");
    }
  },

  /**
   * Buscar dados completos (usuários + estatísticas)
   */
  buscarDadosCompletos: async () => {
    try {
      const [usuariosResponse, estatisticasResponse] = await Promise.all([
        api.get(`${BASE_URL}/admin/tokens/usuarios-logados`),
        api.get(`${BASE_URL}/admin/tokens/estatisticas`)
      ]);

      return {
        usuarios: usuariosResponse.data.data || [],
        estatisticas: estatisticasResponse.data.data || {},
        totalTokens: usuariosResponse.data.total_tokens || 0,
        totalUsuarios: usuariosResponse.data.total || 0
      };
    } catch (error) {
      console.error('Erro ao buscar dados completos:', error);
      throw new Error("Erro ao buscar dados completos.");
    }
  },

  /**
   * Forçar logout de todos os usuários (exceto o atual)
   * @param {string} currentUserLogin - Login do usuário atual (para não deslogar ele mesmo)
   */
  forcarLogoutTodos: async (currentUserLogin) => {
    try {
      const usuariosResponse = await api.get(`${BASE_URL}/admin/tokens/usuarios-logados`);
      const usuarios = usuariosResponse.data.data || [];
      
      // Filtrar para não deslogar o usuário atual
      const outrosUsuarios = usuarios.filter(user => user.login !== currentUserLogin);
      
      const promises = outrosUsuarios.map(user => 
        api.post(`${BASE_URL}/admin/tokens/revogar-usuario/${user.login}`)
      );
      
      const results = await Promise.allSettled(promises);
      
      const sucessos = results.filter(result => result.status === 'fulfilled').length;
      const erros = results.filter(result => result.status === 'rejected').length;
      
      return {
        total: outrosUsuarios.length,
        sucessos,
        erros,
        resultados: results
      };
    } catch (error) {
      console.error('Erro ao forçar logout de todos:', error);
      throw new Error("Erro ao forçar logout de todos os usuários.");
    }
  }
};

export default adminTokenService;